import { camelCase, snakeCase, isObject, isArray } from 'lodash-es';
/**
 * 深度递归属性名转换
 * 处理对象和数组类型的深度递归属性值转换
 * @param obj 处理的目标对象
 * @param parser 转换解析器，默认转小驼峰
 * @returns
 */
type ParserType = typeof camelCase | typeof snakeCase;

export const deepConvertKey = (obj: any, parser: ParserType = camelCase) => {
  if (!obj) {
    return obj;
  }

  Object.keys(obj).forEach(key => {
    const target = obj[key];
    const newKey = parser(key);

    if (isObject(target)) {
      obj[newKey] = deepConvertKey(target, camelCase);
    } else if (isArray(target)) {
      obj[newKey] = deepConvertKey(target, camelCase);
    } else {
      obj[newKey] = obj[key];
    }

    // 如果产生了新的key，则删除旧key
    key !== newKey && delete obj[key];
  });

  return obj;
};

export function isBuffer(buffer: any) {
  return buffer instanceof Buffer;
}

export const stringify = (
  value: any,
  replacer?: (this: any, key: string, value: any) => any,
  space?: string | number
) => {
  let cache: any = [];
  const str = JSON.stringify(
    value,
    replacer ||
      function (key, value) {
        if (typeof value === 'object' && value !== null) {
          if (cache.indexOf(value) !== -1) {
            // 移除
            return;
          }

          // 收集所有的值
          cache.push(value);
        }

        return value;
      },
    space
  );
  cache = null;

  return str;
};
